import React from 'react'
import { useMerchant } from '@contexts/admin/MerchantContext'
import { ecAccountService } from '@services/admin/ecAccountService'
import EcAccountList from '@components/shared/ec_accounts/EcAccountList'

export default function AdminEcAccountsList() {
  const { merchant } = useMerchant()

  return (
    <EcAccountList
      service={ecAccountService}
      role="admin"
      merchants={merchant ? [merchant] : []} // Admin context usually has one merchant focused
      currentMerchant={merchant}
    />
  )
}
